<template>
    <hts-form-file-upload
        v-model="cValue"
        :name="name"
        :file-name="fileName"
        :prop="prop"
        accept=".xlsx, .xls, .csv"
        label="Thêm file số container theo mẫu"
        color="secondary">
        <template #bottom>
            <div>
                <div v-if="fileName && fileUrl">
                    <p
                        class="text-info-500 hover:text-info-600 py-2"
                        @click="downloadTemplate(fileUrl, fileName)">
                        {{ fileName }}
                    </p>
                </div>

                <button
                    type="button"
                    class="mt-2 bg-info-500 text-white py-2 px-4 rounded-md hover:bg-info-600"
                    @click="() => downloadTemplate()">
                    Tải xuống tệp mẫu
                </button>
            </div>
        </template>
    </hts-form-file-upload>
</template>
<script lang="ts" setup>
const props = defineProps({
  modelValue: {
    type: [Array<File>, File, String],
    required: true
  },
  name: {
    type: String,
    default: 'containerNumberFile'
  },
  prop: {
    type: String,
    default: 'containerNumberFile'
  },
  fileName: {
    type: String,
    default: ''
  },
  fileUrl: {
    type: String,
    default: ''
  }
})

const emits = defineEmits(['update:modelValue'])

const { modelValue } = toRefs(props)

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})

const downloadTemplate = (url?: string, name?: string) => {
  const templateUrl = url || '/template/addContainerTemplate.xlsx' // Đường dẫn tuyệt đối
  fetch(templateUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.blob()
    })
    .then((blob) => {
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.href = url
      link.download = name || 'Thêm Số Container Template.xlsx'
      document.body.appendChild(link)
      link.click()
      link.remove()
      URL.revokeObjectURL(url)
    })
    .catch((error) => {
      console.error('Error downloading the template:', error)
    })
}
</script>
